import { Component, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PromptFeaturesComponent } from './features/features.component';
import { PromptOptionsComponent } from './options/options.component';
import { PromptMappingsComponent } from './mappings/mappings.component';
import { PromptManagerComponent } from './prompt-manager/prompt-manager.component';
import { TabOption } from '../../../core/models/prompt-bot.model';
import { IconComponent } from '../../../shared/icons/icon.component';
import { AuditLogPanelComponent } from '../../../shared/components/audit-log-panel/audit-log-panel.component';
import { AuditEntityType } from '../../../core/models/audit-log.model';

@Component({
  selector: 'app-prompt-info',
  standalone: true,
  imports: [
    CommonModule,
    PromptFeaturesComponent,
    PromptOptionsComponent,
    PromptMappingsComponent,
    PromptManagerComponent,
    IconComponent,
    AuditLogPanelComponent
  ],
  templateUrl: './prompt-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./prompt-info.component.scss']
})
export class PromptInfoComponent {
  @ViewChild(AuditLogPanelComponent) auditLogPanel!: AuditLogPanelComponent;
  activeTab = signal<TabOption['id']>('FEATURES');

  tabs: TabOption[] = [
    { id: 'FEATURES', label: 'Features', icon: 'sparkles' },
    { id: 'MAPPINGS', label: 'Mappings', icon: 'gitCommitHorizontal' },
    { id: 'FEATURE_OPTIONS', label: 'Feature Variants', icon: 'settings' },
    { id: 'PROMPTS', label: 'Prompt Manager', icon: 'bookOpenCheck' },
  ];

  promptEntityTypes = [
    AuditEntityType.PROMPT,
    AuditEntityType.PROMPT_FEATURE,
    AuditEntityType.PROMPT_OPTION,
    AuditEntityType.PROMPT_MAPPING
  ];

  /**
   * Enables horizontal scrolling with the mouse wheel with ease.
   * Hijacks vertical scroll to move horizontally when over the tab bar.
   */
  onTabsWheel(event: WheelEvent): void {
    const container = event.currentTarget as HTMLElement;
    const scrollAmount = event.deltaY;
    const canScrollLeft = container.scrollLeft > 0;
    const canScrollRight = container.scrollLeft < (container.scrollWidth - container.clientWidth);

    // Only hijack vertical scroll for horizontal movement if the container is scrollable
    // and we haven't reached the boundary in the scroll direction.
    // This allows the user to continue scrolling the page once they hit the end of the tabs.
    if (Math.abs(scrollAmount) > 0) {
      if ((scrollAmount > 0 && canScrollRight) || (scrollAmount < 0 && canScrollLeft)) {
        container.scrollLeft += scrollAmount;
        event.preventDefault();
      }
    }
  }

  reloadAuditLogs() {
    this.auditLogPanel?.reloadLogs();
  }
}
